import { useQuery } from "@tanstack/react-query";

import { supabase } from "@/shared/lib/supabase";

export function useAttorneyHelplineEnabled() {
  const { data: enabled = false } = useQuery({
    queryKey: ["supabase-feature-flags", "attorney_helpline_enabled"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("feature_flags")
        .select("enabled")
        .eq("name", "attorney_helpline_enabled")
        .single();

      if (error) throw error;
      return data?.enabled ?? false;
    },
    staleTime: 30_000,
  });

  return enabled;
}
